import { ChangeEvent, KeyboardEvent, useEffect, useState } from "react"
import { KTSVG, toAbsoluteUrl } from "../../../_metronic/helpers"
import "./appListing.scss"
import { Input, message } from 'antd'
import Select from 'react-select'
import { ChromePicker } from 'react-color'
import rgbHex from 'rgb-hex'
import clsx from "clsx"
import { Divider } from "@material-ui/core"
import { Link, useHistory, useParams } from "react-router-dom"
import axios from "axios"
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { handleFileUpload } from "../../../setup/Upload/Upload"
import httpService from "../../../setup/http/httpServices"

interface Params {
    id: string;
}

const AddApp = () => {

    const history: any = useHistory()
    const [fontCollection, setFontCollection] = useState([{ value: '', label: '' }])
    const [fontFamily, setFontFamily] = useState([{ value: '', label: '' }])
    const [fonts, setFonts] = useState([])
    const [colors, setColors] = useState([])
    const [pickerShow, setPickerShow] = useState(false)
    const [colorErr, setColorErr] = useState(false)
    const [fontErr, setFontErr] = useState(false)
    const [colorErr2, setColorErr2] = useState(false)
    const [color, setColor] = useState('#fff')
    const [phraseInput, setPhraseInput] = useState<string>('')
    const [phrase, setPhrase] = useState<string[]>([])
    const [errorMessage, setErrorMessage] = useState('');
    const [suggestedPhrases, setSuggestedPhrases] = useState([])
    const [selectAllMode, setSelectAllMode] = useState<boolean>(true);
    const [phraseErr, setPhraseErr] = useState(false)
    const [DesktopSS, setDesktopSS] = useState('')
    const [loadingDesk, setLoadingDesk] = useState(false)
    const [desktopLoading, setDesktopLoading] = useState(false)
    const [logoImage, setlogoImage] = useState('');
    const [coverImage, setCoverImage] = useState('');
    const [template, setTemplate] = useState(false);
    const [isStatus, setIsStatus] = useState(false)
    const [searchValue, setSearchValue] = useState('')
    const [selectedCategories, setSelectedCategories] = useState([])
    const [categories, setCategories] = useState([])
    const [error, setError] = useState(false)
    const [loading, setLoading] = useState(false)

    console.log('isStatus', isStatus)
    // console.log('edit', history.location.state?.edit)
    // console.log('basicDetail by id', history.location.state?.appListing)
    // console.log('info app_id', history.location.state?.app_id)

    var initialValues = {
        appName: '' || history.location.state?.appListing?.app_name,
        description: '' || history.location.state?.appListing?.app_description,
        appTag: '' || history.location.state?.appListing?.app_tag_name,
        creatorName: '' || history.location.state?.appListing?.creator_name,
        playStoreUrl: '' || history.location.state?.appListing?.play_store_url,
        appStoreUrl: '' || history.location.state?.appListing?.app_store_url,
        marketplace: '',

    }
    const appSchema = Yup.object().shape({
        appName: Yup.string()
            .required('App Name is required'),
        description: Yup.string()
            .required('App Description is required'),
        // marketplace: Yup.string()
        //     .required('Marketplace Link is required'),

    })


    console.log('history.location.state?.appListing', history.location.state?.appListing)
    useEffect(() => {
        if (history.location.state?.edit) {
            const arr1 = []
            const arr2 = []
            for (const i of history.location.state?.appListing?.font_family) {
                const obj = {
                    value: i.collection,
                    label: i.collection
                }
                arr1.push(obj)
                arr2.push(i.family)
            }
            setFontCollection(arr1)
            setFonts(arr2)
            setSelectedCategories(history.location.state?.appListing?.categories)
            setColors(history.location.state?.appListing?.colors)
            setCoverImage(history.location.state?.appListing?.cover_image)
            setlogoImage(history.location.state?.appListing?.app_logo)
            setPhrase(history.location.state?.appListing?.phrases)
            setIsStatus(history.location.state?.appListing?.app_status)
        }
    }, [])

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: appSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
            const arr = []
            for (let i = 0; i < fonts.length; i++) {
                const obj = {
                    collection: fontCollection[i]?.value,
                    family: fonts[i]
                }
                arr.push(obj)
            }
            // console.log(arr)

            // const formattedCategories = selectedCategories.map((category) => ({
            //     _id: category._id,
            //     Name: category.Name,
            //     AssociatedPhrases: category.AssociatedPhrases, // Include AssociatedPhrases
            // }));


            const fd = {
                app_name: values.appName,
                app_description: values.description,
                app_tag_name: values.appTag,
                creator_name: values.creatorName,
                app_store_url: values.appStoreUrl,
                play_store_url: values.playStoreUrl,
                phrases: phrase,
                app_logo: logoImage,
                cover_image: coverImage,
                colors: colors,
                font_family: arr,
                categories: selectedCategories,
                isTemplate: template,
                app_status: isStatus,

            }

            // history.push({
            //     pathname: '/mobile-application/add-screens',
            // })

            console.log('form Data', fd)
            if (history.location.state?.edit) {
                const id = history.location.state?.appListing?._id
                httpService.patchData(
                    `/app/${id}`,
                    fd,
                    (res) => {
                        console.log("Info Updated", res)
                        setLoading(false)
                        history.push({
                            pathname: '/mobile-application/add-screens',
                            state: {
                                ...history.location.state,
                                app_id: res.data?.data?._id,
                            },
                        })
                    },
                    (err) => {
                        setLoading(false)
                        console.log(err)
                    }
                )
            } else {
                httpService.postData(
                    '/app',
                    fd,
                    (res) => {
                        console.log("info Data", res)
                        setLoading(false)
                        history.push({
                            pathname: '/mobile-application/add-screens',
                            state: {
                                ...history.location.state,
                                app_id: res.data?.data?._id
                            },
                        })
                    },
                    (err) => {
                        setLoading(false)
                        console.log(err)
                    }
                )
            }


        }
    })

    const handleTemplateChange = (value) => {
        setTemplate(value);
    };

    const handleStatusChange = (value) => {
        setIsStatus(value);
    };


    const handleLogoImageChange = async (event: any) => {
        const d = await handleFileUpload(event, 220, 220, setDesktopLoading);
        console.log(d);
        setlogoImage(d ? d : '');
    };

    const handleCoverImageChange = async (event: any) => {
        const d = await handleFileUpload(event, undefined, undefined, setDesktopLoading);
        console.log(d);
        setCoverImage(d ? d : '');
    }



    function handleColorPick() {
        if (pickerShow) {
            console.log(colors.includes(color.toUpperCase()), color)

            let x = [...colors]
            if (!x.includes(color.toUpperCase())) {
                setColorErr2(false)
                x.push(color.toUpperCase())
                x.length >= 2 ? setColorErr(false) : setColorErr(true)
                setColors(x)
            } else {
                setColorErr2(true)
                setColorErr(false)
            }
            console.log(colors)
        }
        setPickerShow(!pickerShow)
    }
    function deleteColor(index) {
        let x = [...colors]
        x.splice(index, 1)
        setColors(x)
    }


    const deleteFont = (index: number) => {
        const updatedFonts = [...fonts];
        const updatedFontCollection = [...fontCollection];

        updatedFonts.splice(index, 1);
        updatedFontCollection.splice(index, 1);

        setFonts(updatedFonts);
        setFontCollection(updatedFontCollection);
    };


    const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        setPhraseInput(e.target.value);
    };

    const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
        console.log("key", e.key)
        if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault();
            addPhrase();
        }
    };

    const addPhrase = () => {
        if (phraseInput.trim() !== '') {
            const updatedPhrases = [...phrase, phraseInput.trim().replace(/,$/, '')];
            setPhrase(updatedPhrases);
            setPhraseInput('');
        }
    };

    const handleRemovePhrase = (phraseIndex: number) => {
        setPhrase((prevPhrases) => prevPhrases.filter((_, index) => index !== phraseIndex));
    };

    const handleSuggestionClick = (suggestedPhrase: string) => {
        const lowerCaseSuggestedPhrase = suggestedPhrase.toLowerCase();
        const lowerCasePhrases = phrase.map(item => item.toLowerCase());
        if (lowerCasePhrases.includes(lowerCaseSuggestedPhrase)) {
            setErrorMessage('Phrase already exists');
        } else {
            // If not, add the suggestedPhrase to the array and clear the error message
            const updatedPhrases = [...phrase, suggestedPhrase];
            setPhrase(updatedPhrases);
            setErrorMessage('');
        }
        setSelectAllMode(false)
    };

    const handleToggleSelectAllSuggestions = () => {
        const allSuggestedPhrases = selectedCategories?.flatMap((item) => item.AssociatedPhrases);

        if (selectAllMode) {
            setPhrase(allSuggestedPhrases);
        } else {
            setPhrase([]);
        }
        setSelectAllMode(!selectAllMode);
    };

    // Google Font family
    useEffect(() => {
        axios
            .get(
                'https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyBvfBEEPr2ARh7vEhUQWJr71uKxrfHZTrQ'
            )
            .then((res) => {
                console.log(res.data.items)
                let x = [{ value: '', label: '' }]
                res.data.items.forEach((a) => {
                    let y = { value: a.family, label: a.family }
                    x.push(y)
                })

                setFontFamily(x)
            })
        // }
    }, [fontCollection])




    const searchHandler = (e: any) => {
        setSearchValue(e.target.value)
    }

    const checkHandle = (cat) => {
        const selectedIndex = selectedCategories.findIndex((c) => c._id === cat._id);
        let updatedSelectedCategories = [...selectedCategories];

        if (selectedIndex === -1) {
            updatedSelectedCategories.push({ _id: cat._id, Name: cat.Name, AssociatedPhrases: cat?.AssociatedPhrases });
        } else {
            updatedSelectedCategories.splice(selectedIndex, 1);
        }

        setSelectedCategories(updatedSelectedCategories);
        setError(updatedSelectedCategories.length === 0);
        setCategories([...categories]); // This line may not be necessary depending on your use case
    };

    // const handleCategorySelectAll = () => {
    //     const allCategoriesSelected = selectedCategories.length === categories.length;
    //     if (allCategoriesSelected) {
    //         setSelectedCategories([]);
    //         setError(true);
    //     } else {
    //         setSelectedCategories([...categories]);
    //         setError(false);
    //     }
    // };


    useEffect(() => {
        httpService.getData(
            '/category-master?search=' + searchValue,
            (res) => {
                console.log(res.data.data.data)
                setCategories(res.data.data.data)
            },
            (err) => {
                message.error('Not able to fetch.')
            }
        )
    }, [searchValue])

    console.log('SelectedCategories', selectedCategories)

    return (
        <>
            <form onSubmit={formik.handleSubmit} className="app-listing-container">
                <div className="appListingCard">
                    <h2>Basic Details</h2>
                    <div className="row">

                        <div className="col logo-box">
                            <div className="imgBox">
                                {logoImage ? (
                                    <img src={logoImage} alt="Preview" className="preview-image" />
                                ) : (
                                    <label htmlFor="file-input" className="add-icon">
                                        <KTSVG path={toAbsoluteUrl('/media/icons/Custom/Add.svg')} />
                                    </label>
                                )}
                                <input
                                    id="file-input"
                                    type="file"
                                    onChange={handleLogoImageChange}
                                    accept="image/*"
                                    style={{ display: 'none' }}
                                />
                            </div>
                            <div className="text-div">
                                <h3 className="required">App Logo</h3>
                                <p>Dimensions: 220px * 220px </p>
                            </div>

                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <h6 className='fw-bold required'>Enter App Name</h6>
                            <Input
                                className={'form-control-solid rounded-4 shadow-none bg-gray-100'}
                                style={{ padding: '0.65rem !important', height: '38px' }}
                                placeholder="App name goes here"
                                onChange={(e) => {
                                    formik.setFieldValue('appName', e.target.value)

                                }}
                                value={formik.values.appName}
                            />
                        </div>
                        <div className="col">
                            <h6 className='fw-bold'>App Tag Line</h6>
                            <Input
                                className={'form-control-solid rounded-4 shadow-none bg-gray-100'}
                                style={{ padding: '0.65rem !important', height: '38px' }}
                                placeholder="App tag line goes here"
                                onChange={(e) => {
                                    formik.setFieldValue('appTag', e.target.value)

                                }}
                                value={formik.values.appTag}

                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <h6 className='fw-bold required'>Enter Description</h6>
                            <Input
                                className={'form-control-solid rounded-4 shadow-none bg-gray-100'}
                                style={{ padding: '0.65rem !important', height: '38px' }}
                                placeholder="App name goes here"
                                onChange={(e) => {
                                    formik.setFieldValue('description', e.target.value)

                                }}
                                value={formik.values.description}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col" style={{ display: "flex", alignItems: "center" }}>
                            <h6 className='fw-bold required'>Upload Cover Image</h6>
                        </div>
                        <div className="col">
                            <div className="coverImage-upload-box">
                                <div>
                                    {!loadingDesk && (
                                        <button
                                            type='button'
                                            className='btn btn-gray-200 screenshotComponentBtn border border-gray-500 w-200px mx-4'
                                            disabled={loadingDesk}
                                            onClick={() => {
                                                document.getElementById('desktopManual')?.click();
                                            }}
                                        >
                                            {loadingDesk ? "Uploading..." : coverImage ? 'Click to Re-Upload' : 'Click to Upload'}
                                        </button>
                                    )}
                                    <input
                                        type='file'
                                        accept='.png, .jpg, .jpeg, .svg, .webp'
                                        style={{ display: 'none' }}
                                        id='desktopManual'
                                        onChange={handleCoverImageChange}
                                    />
                                    <button
                                        type='button'
                                        className={
                                            !coverImage
                                                ? 'btn btn-gray-200 screenshotComponentBtn border border-gray-500'
                                                : 'screenshotComponentBtn'
                                        }
                                        disabled={!coverImage}
                                        onClick={() => {
                                            window.open(coverImage, '_blank')
                                        }}
                                    >
                                        {!loadingDesk && coverImage && (
                                            <img src='/media/icons/Custom/eye.svg' alt='eye' />
                                        )}
                                        &nbsp; Preview
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="appListingCard">
                    <h2 >
                        Additional Details
                    </h2>
                    <div className='d-flex align-items-center'>
                        <h6 className="fw-bold required">Is this a template</h6>
                        <div className='form-check form-check-custom form-check-solid form-check-sm m-3'>
                            <input
                                className='form-check-input'
                                name='template-yes'
                                type='radio'
                                id='template-yes'
                                onChange={() => handleTemplateChange(true)}
                                checked={template}
                            />
                            <label className='form-check-label' htmlFor='template-yes'>
                                Yes
                            </label>
                        </div>
                        <div className='form-check form-check-custom form-check-solid form-check-sm m-3'>
                            <input
                                className='form-check-input'
                                name='template-no'
                                type='radio'
                                id='template-no'
                                onChange={() => handleTemplateChange(false)}
                                checked={!template}
                            />
                            <label className='form-check-label' htmlFor='template-no'>
                                No
                            </label>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col">
                            <h6 className='fw-bold'>Enter Creator Name (optional)</h6>
                            <Input
                                className={'form-control-solid rounded-4 shadow-none bg-gray-100'}
                                style={{ padding: '0.65rem !important', height: '38px' }}
                                placeholder="App name goes here"
                                onChange={(e) => {
                                    formik.setFieldValue('creatorName', e.target.value)

                                }}
                                value={formik.values.creatorName}
                            />
                        </div>
                        <div className="col">
                            <h6 className='fw-bold'>App Store URL</h6>
                            <Input
                                className={'form-control-solid rounded-4 shadow-none bg-gray-100'}
                                style={{ padding: '0.65rem !important', height: '38px' }}
                                placeholder="URL goes here"
                                suffix={
                                    <>
                                        <img src={toAbsoluteUrl('/media/logos/link.svg')} alt="dribble" />
                                    </>
                                }
                                onChange={(e) => {
                                    formik.setFieldValue('appStoreUrl', e.target.value)

                                }}
                                value={formik.values.appStoreUrl}
                            />
                        </div>

                        <div className="col">
                            <h6 className='fw-bold'>Play Store URL</h6>
                            <Input
                                className={'form-control-solid rounded-4 shadow-none bg-gray-100'}
                                style={{ padding: '0.65rem !important', height: '38px' }}
                                placeholder="URL goes here"
                                suffix={
                                    <>
                                        <img src={toAbsoluteUrl('/media/logos/link.svg')} alt="dribble" />
                                    </>
                                }
                                onChange={(e) => {
                                    formik.setFieldValue('playStoreUrl', e.target.value)

                                }}
                                value={formik.values.playStoreUrl}
                            />
                        </div>
                    </div>
                    {/* {
                        template && (
                            <div className="row">
                                <div className="col">
                                    <h6 className='fw-bold required'>Marketplace Link</h6>
                                    <Input
                                        className={'form-control-solid rounded-4 shadow-none bg-gray-100'}
                                        style={{ padding: '0.65rem !important', height: '38px' }}
                                        placeholder="Enter Marketplace Link"
                                        onChange={(e) => {
                                            formik.setFieldValue('marketplace', e.target.value)

                                        }}
                                        value={formik.values.creatorName}
                                    />
                                </div>
                            </div>
                        )
                    } */}
                </div>
                <div className="appListingCard">
                    <h2 className=''>Select App Categories</h2>

                    <div className="row">
                        <div className="col">
                            <div className='row pt-4 pe-5 '>
                                <div className='col'>
                                    <Input
                                        type='text'
                                        placeholder='Search Categories.'
                                        className='form-control-solid rounded-6 border shadow-none pe-6 bg-white-100 mb-5'
                                        onChange={searchHandler}
                                        value={searchValue}
                                        prefix={
                                            <>
                                                <img src={toAbsoluteUrl('/media/icons/Custom/Search.svg')} alt='link' />
                                            </>
                                        }
                                    />
                                </div>
                            </div>

                            <div className='row pe-5 pb-5 '>
                                <div className='col scrollContainer'>
                                    {categories?.map((cat, ind) => {
                                        return (
                                            <div className='form-check form-check-custom form-check-solid form-check-sm m-4'>
                                                <input
                                                    className='form-check-input'
                                                    type='checkbox'
                                                    value={cat._id}
                                                    id={cat._id}
                                                    checked={selectedCategories?.findIndex((c) => c._id === cat._id) > -1}
                                                    onClick={() => checkHandle(cat)}
                                                />
                                                <label className='form-check-label' htmlFor={cat.Name}>
                                                    {cat.Name}
                                                </label>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                            <p className="line"></p>
                            <div className='row pt-4 pe-5 '>
                                <div className='col d-flex flex-row  justify-content-start align-items-center flex-wrap'>
                                    {selectedCategories &&
                                        selectedCategories?.map((x, ind) => {
                                            return (
                                                <div
                                                    className='d-flex align-items-center justify-content-around border px-3 py-2 m-2 rounded-pill'
                                                    id={x._id}
                                                >
                                                    {x.Name}
                                                    <img
                                                        style={{ paddingLeft: '5px', cursor: 'pointer', display: 'inline' }}
                                                        onClick={() => checkHandle(x)}
                                                        src={toAbsoluteUrl('/media/icons/Custom/Cross.svg')}
                                                        alt='cross'
                                                    />
                                                </div>
                                            )
                                        })}
                                </div>
                            </div>
                        </div>
                    </div>


                </div>

                <div className='appListingCard'>
                    <h6 className='fw-bolder'>Font Details</h6>

                    {fonts.map((font, i) => {
                        return (
                            <div className='row pt-4 '>
                                <div className='col-5 '>
                                    <h6 className='fw-bold required'>Select Fonts Collection</h6>
                                    <Select
                                        isMulti={false}
                                        name='agencyAssociated'
                                        placeholder='Select Fonts Collection'
                                        styles={{
                                            menuList: (provided, state) => ({
                                                ...provided,
                                                height: 'auto',
                                                maxHeight: '200px',
                                            }),
                                        }}
                                        value={fontCollection[i]}
                                        options={[{ value: '', label: 'Select Font' }, { value: 'Google Fonts', label: 'Google Fonts' }, { value: 'Other', label: 'Other' }]}
                                        className={clsx(
                                            'form-control-solid rounded-4 bg-gray-100 p-0 border-0 categorySelect'
                                        )}
                                        onChange={(e) => {
                                            console.log(e)
                                            let x = [...fontCollection]
                                            x[i] = e
                                            setFontCollection(x)
                                        }}
                                    />
                                </div>
                                <div className='col-5 '>
                                    <h6 className='fw-bold required'>Select Font Family</h6>
                                    {
                                        fontCollection[i].value === 'Other' ?
                                            <Input
                                                className={'form-control-solid rounded-4 shadow-none bg-gray-100'}
                                                style={{ padding: '0.65rem !important', height: '38px' }}
                                                value={fonts[i]}
                                                onChange={(e) => {
                                                    let x = [...fonts]
                                                    x[i] = e.target.value
                                                    setFonts(x)
                                                }}
                                            />
                                            :
                                            <Select
                                                isMulti={false}
                                                isDisabled={fontCollection[i].value === ''}
                                                value={{ label: fonts[i], value: fonts[i] }}
                                                name='Font Family'
                                                placeholder='Select Font Family'
                                                styles={{
                                                    menuList: (provided, state) => ({
                                                        ...provided,
                                                        height: 'auto',
                                                        maxHeight: '200px',
                                                    }),
                                                }}
                                                className={clsx(
                                                    'form-control-solid rounded-4 bg-gray-100 p-0 border-0 categorySelect'
                                                )}
                                                options={fontFamily}
                                                onChange={(e) => {
                                                    console.log(e)
                                                    let x = [...fonts]
                                                    x[i] = e.label
                                                    setFonts(x)
                                                }}
                                            />
                                    }

                                </div>
                                <div className='col-2'>
                                    {i !== 0 && ( // Check if it's not the first entry
                                        <button
                                            type='button'
                                            className='btn fw-bolder  m-0 mt-5 mb-0'
                                            onClick={() => deleteFont(i)}
                                        >
                                            <img
                                                className='cursor-pointer'
                                                src={toAbsoluteUrl('/media/icons/Custom/Dustbin.svg')}
                                                style={{ marginBottom: '0', marginRight: '8px', marginLeft: '5%' }}
                                                alt='delete'
                                            />
                                        </button>
                                    )}
                                </div>


                                {fontErr && (
                                    <div className='fv-plugins-message-container'>
                                        <div className='fv-help-block'>
                                            <span className='text-danger' role='alert'>
                                                {'Font required'}
                                            </span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )
                    })}

                    <button
                        type='button'
                        // disabled={fonts[i] === ''}
                        className='btn fw-bolder btn-gray-200 m-0 mt-5 mb-0'
                        style={{
                            background: '#F9FAFC',
                            border: '2px solid #E5E9F2',
                            color: '#9099A4',
                            width: "250px"
                        }}
                        onClick={() => {
                            let x = [...fonts]
                            let y = [...fontCollection]
                            x.push('')
                            y.push({ value: '', label: '' })
                            setFonts(x)
                            setFontCollection(y)
                        }}
                    >
                        <img
                            src={toAbsoluteUrl('/media/icons/duotune/abstract/abs011.svg')}
                            alt='add'
                            style={{
                                transform: 'rotate(90deg)',
                                width: '14px',
                                marginLeft: '-8px',
                                marginRight: '6px',
                            }}
                        ></img>
                        {fonts?.length ? "Add More" : "Add Font"}
                    </button>


                </div>


                <div className='appListingCard'>
                    <div className="color-box">
                        <h6 className='fw-bolder required'>Colors</h6>
                        {colors.map((c, index) => {
                            console.log(c)
                            let style = {
                                backgroundColor: c,
                                width: '32px',
                                height: '32px',
                                borderRadius: '40px',
                                marginBottom: '0',
                            }

                            return (
                                <span
                                    className='btn-white bg-white-100 border border-gray-300 AddColors d-inline-flex justify-content-start align-items-center my-3'
                                    style={{ marginRight: '10px' }}
                                >
                                    <p style={style} className='border border-gray-300'></p>
                                    <p style={{ marginBottom: '0', width: '80px', marginLeft: '12px' }}>{c}</p>
                                    <div style={{ margin: 'auto' }}>
                                        <img
                                            className='cursor-pointer'
                                            src={toAbsoluteUrl('/media/icons/Custom/Dustbin.svg')}
                                            style={{ marginBottom: '0', marginRight: '0', marginLeft: '5%' }}
                                            alt='delete'
                                            onClick={() => deleteColor(index)}
                                        ></img>
                                    </div>
                                </span>
                            )
                        })}

                        <div className='d-flex pt-4 pe-5 pb-0 mb-0'>
                            <button
                                type='button'
                                className='btn fw-bolder btn-gray-200 AddColors d-inline mb-0'
                                style={{ background: '#F9FAFC', border: '2px solid #E5E9F2', color: '#9099A4', width: "250px" }}
                                onClick={() => handleColorPick()}
                            >
                                <img
                                    src={toAbsoluteUrl('/media/icons/duotune/abstract/abs011.svg')}
                                    alt='add'
                                    style={{
                                        transform: 'rotate(90deg)',
                                        width: '14px',
                                        marginLeft: '-8px',
                                        marginRight: '6px',
                                    }}
                                ></img>
                                {pickerShow ? 'Choose' : colors.length ? 'Add More Color' : 'Add Color'}
                            </button>
                        </div>
                        <div className='d-flex pt-4 pe-5'>
                            {pickerShow && (
                                <ChromePicker
                                    style={{ position: 'absolute', top: '10px' }}
                                    color={color}
                                    onChange={(updatedColor) => {
                                        console.log(updatedColor)
                                        setColor(
                                            '#' +
                                            rgbHex(
                                                updatedColor.rgb.r,
                                                updatedColor.rgb.g,
                                                updatedColor.rgb.b,
                                                // updatedColor.rgb.a
                                            )
                                        )
                                    }}
                                />
                            )}
                            {colorErr && (
                                <div className='fv-plugins-message-container'>
                                    <div className='fv-help-block'>
                                        <span className='text-danger' role='alert'>
                                            {'Two colors minimum required'}
                                        </span>
                                    </div>
                                </div>
                            )}
                            {colorErr2 && (
                                <div className='fv-plugins-message-container'>
                                    <div className='fv-help-block'>
                                        <span className='text-danger' role='alert'>
                                            {'Two colors cannot be same'}
                                        </span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className="appListingCard">
                    <h2 className=''>App Phrases</h2>

                    <div className="suggest-phrases-box">
                        <div className="suggest-header-box">
                            <p style={{ marginTop: "2rem", padding: 0 }}>Suggested Phrases from Category Master</p>
                            <div className='custom-btn' onClick={handleToggleSelectAllSuggestions}>
                                {selectAllMode ? 'Select All Phrases' : 'Cancel All Phrases'}
                            </div>
                        </div>
                        <div className="suggest-phrases">
                            {selectedCategories?.map((item, index) => (
                                <div key={index} className='phrases-box'>
                                    {item?.AssociatedPhrases?.map((item: any, index: any) => (
                                        <div className='phrases' onClick={() => handleSuggestionClick(item)} key={index}>{item}</div>
                                    ))}
                                </div>
                            ))}
                        </div>

                    </div>

                    <div className="row">
                        <div className="col">

                            <p className='required' style={{ marginTop: "12px" }}>Select or add phrases (comma separated values)</p>
                            {phraseErr && <p className='text-danger'>Atleast one phrase is required</p>}



                            <div className='website-phrases-field'>
                                {phrase.map((phrase, index) => (
                                    <div className='d-flex align-items-center justify-content-around border px-3 py-2 m-2 rounded-pill'>
                                        {phrase}
                                        <img
                                            style={{ paddingLeft: '5px', cursor: 'pointer', display: 'inline' }}
                                            onClick={() => handleRemovePhrase(index)}
                                            src={toAbsoluteUrl('/media/icons/Custom/Cross.svg')}
                                            alt='cross'
                                        />
                                    </div>
                                ))}

                                <input
                                    type='text'
                                    onChange={handleInputChange}
                                    onKeyUp={handleKeyDown}
                                    value={phraseInput}
                                />
                            </div>

                            {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}
                        </div>
                    </div>


                </div>
                <div className="appListingCard" style={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                    <h2>App Publishing Status</h2>
                    <div className='d-flex align-items-center'>
                        <div className='form-check form-check-custom form-check-solid form-check-sm m-3'>
                            <input
                                className='form-check-input'
                                name='under-review'
                                type='radio'
                                id='under-review'
                                onChange={() => handleStatusChange(false)}
                                checked={isStatus === false}
                            />
                            <label className='form-check-label' htmlFor='under-review'>
                                Under Review
                            </label>
                        </div>
                        <div className='form-check form-check-custom form-check-solid form-check-sm m-3'>

                            <input
                                className='form-check-input'
                                name='publish'
                                type='radio'
                                id='publish'
                                onChange={() => handleStatusChange(true)}
                                checked={isStatus === true}
                            />
                            <label className='form-check-label' htmlFor='publish'>
                                Publish
                            </label>
                        </div>
                    </div>
                </div>

                <div className='d-flex pt-4 pe-5'>
                    {/* <Link to={{ pathname: "/mobile-application/add-screens" }}> */}
                    <button
                        type='submit'
                        id='kt_sign_up_submit'
                        className='btn btn-primary ms-5 CompanyDetailButton'
                    >
                        <span className='indicator-label'>Save and Proceed</span>

                    </button>
                    {/* </Link> */}
                    <Link
                        to={{
                            pathname: '/mobile-application/app-listing',
                        }}
                    >
                        <button type='button' className='btn fw-bolder btn-gray-200 ms-5 CompanyDetailButton'>
                            Cancel
                        </button>
                    </Link>
                </div>
            </form>
        </>
    )
}

export default AddApp